import { useScrollReveal } from "@/hooks/useScrollReveal";

// Gemeinsame Bausteine der aufgewerteten Kundenseiten (Vorschau)

export const Ornament = ({ className = "", ton = "#BA6D52" }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`}>
    <span className="w-14 h-px" style={{ backgroundColor: `${ton}66` }} />
    <span className="w-2 h-2 rotate-45 border" style={{ borderColor: ton }} />
    <span className="w-14 h-px" style={{ backgroundColor: `${ton}66` }} />
  </div>
);

export const Reveal = ({ children, delay = 0, className = "", testid }) => {
  const [ref, da] = useScrollReveal();
  return (
    <div ref={ref} data-testid={testid}
      className={`transition-all duration-[900ms] ease-out ${className} ${
        da ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
      style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

export const Kicker = ({ children, ton = "text-[#BA6D52]" }) => (
  <p className={`text-[10px] uppercase tracking-[0.3em] ${ton}`}>{children}</p>
);

export const Titel = ({ children, className = "" }) => (
  <h2 className={`font-serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight leading-[1.1] ${className}`}>
    {children}
  </h2>
);

export const PrimaryBtn = ({ children, className = "", ...rest }) => (
  <a {...rest}
    className={`inline-flex items-center justify-center gap-2.5 bg-[#BA6D52] text-white hover:bg-[#9C4F31] hover:-translate-y-0.5 hover:shadow-[0_16px_34px_-20px_rgba(156,79,49,0.8)] px-8 py-4 text-[11px] uppercase tracking-[0.22em] transition-all duration-300 ${className}`}>
    {children}
  </a>
);

export const GhostBtn = ({ children, className = "", ...rest }) => (
  <a {...rest}
    className={`inline-flex items-center justify-center gap-2.5 border border-[#D8C9B6] text-[#2B2320] hover:border-[#BA6D52] hover:text-[#BA6D52] px-8 py-4 text-[11px] uppercase tracking-[0.22em] transition-colors duration-300 ${className}`}>
    {children}
  </a>
);

// Hochformat-Handyfotos im Passepartout, damit nichts beschnitten wirkt
export const FotoKarte = ({ src, titel, text, hoch = false, testid }) => (
  <figure data-testid={testid}
    className="group bg-[#FFFDF8] border border-[#E6D8C2] p-2.5 hover:-translate-y-1 hover:shadow-[0_26px_50px_-34px_rgba(120,80,48,0.6)] transition-all duration-500">
    <div className={`overflow-hidden ${hoch ? "aspect-[3/4]" : "aspect-[4/3]"}`}>
      <img src={src} alt={titel} loading="lazy"
        className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
    </div>
    {(titel || text) && (
      <figcaption className="px-2 pt-4 pb-2">
        {titel && <p className="font-serif text-lg text-[#2B2320]">{titel}</p>}
        {text && <p className="text-xs text-[#8B7A68] mt-1 italic">{text}</p>}
      </figcaption>
    )}
  </figure>
);

export const FotoBand = ({ src, children, hoehe = "h-[60vh]", dunkel = 0.62 }) => (
  <section className={`relative overflow-hidden ${hoehe}`}>
    <div className="absolute inset-0 bg-cover bg-center animate-kenburns"
      style={{ backgroundImage: `url('${src}')` }} />
    <div className="absolute inset-0" style={{ backgroundColor: `rgba(18,16,12,${dunkel})` }} />
    <div className="relative h-full flex items-center justify-center text-center px-6">
      {children}
    </div>
  </section>
);
